module.exports = "../images/cabin-8-person-2.jpg?v=b325ad3";